import {
    CARGAR_PROFORMAS,
    CARGAR_EMBALAJE,
    CARGAR_PTOSFACTURACION,
    SELECCIONAR_PTOFACTURACION,
    CARGAR_FACTURA,
    CARGAR_FACTURAS,
    CARGAR_PAGOS_FACTURA,
    CARGAR_DEVOLUCION_ELECTRON,
    CARGAR_DEVOLUCION,
    CARGAR_FACTURAS_PENDIENTESGUIAREMISION,
    CARGAR_GUIAREMISION,
    CARGAR_DEVOL_ELECTRONICAS,
    SET_DOCSPORIMPRIMIR,
    UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR,
    INICIALIZAR_FACTURA,
    CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA,
    DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA,
    UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR,
    RESET_ITEMS_A_ENCARTONAR,
    ADD_CARTON,
    DELETE_CARTON,
    UPDATE_CARTON,
    UPDATE_COD_ULT_CARTON,
    UPDATE_PESO_CARTON,
    UPDATE_FLAG_PESO_AUTOMATICO,
    CARGAR_PROFORMAS_A_ENCARTONAR,
    UPDATE_ESTADO_PROFORMA_ENCARTONADA,
    CARGAR_ENCARTONADO,
    SET_ENCARTONADO_ID,
    SET_ENCARTONADO_OBSERVACION,
    SET_ENCARTONADO_FECHA,
    RESET_PROFORMAS_A_ENCARTONAR,
} from '../actions/ventas/actionTypes';
import {groupBy} from "../funciones_globales/arrays";
import {esNumero} from "../funciones_globales/utils";

const estadoInicial =  {    proformas:[], embalajeSel: {}, puntosFact: [], ptoFacturacionSel : null, facturaSel: {}, facturas: [],
                            devolucionElectronSel: {}, devolucionSel: {}, guiaRemisionSel: {}, devolElectronicas: [], docsPorImprimir: [],
                            proformasAEncartonar: [], itemsAEncartonar: [], resumenCartones: [], pesosDeCartones: new Map(), ultimoCodCarton: '', encartonadoId: '',
                            encartonadoObservacion: '', encartonadoFecha: null,
                       };

const ventasReducer = (state=estadoInicial, action) => {
    let itemsAEncartonarNewState = [];
    switch(action.type){
        case CARGAR_PROFORMAS:
            return { ...state, proformas: action.data};
        case CARGAR_EMBALAJE:
            return { ...state, embalajeSel: action.data};
        case CARGAR_PTOSFACTURACION:
            return { ...state, puntosFact: action.data};
        case SELECCIONAR_PTOFACTURACION:
            return { ...state, ptoFacturacionSel: action.idPtoFacturacion};
        case CARGAR_FACTURA:
            return {...state, facturaSel: action.data};
        case CARGAR_DEVOLUCION_ELECTRON:
            return {...state, devolucionElectronSel: action.data};
        case CARGAR_FACTURAS:
        case CARGAR_FACTURAS_PENDIENTESGUIAREMISION:
            return {...state, facturas: action.data};
        case CARGAR_DEVOLUCION:
            return {...state, devolucionSel: action.data};
        case CARGAR_GUIAREMISION:
            return {...state, guiaRemisionSel: action.data};        
        case CARGAR_DEVOL_ELECTRONICAS:
            return {...state, devolElectronicas: action.data };
        case CARGAR_PAGOS_FACTURA:
            return {...state, facturaSel: {...state.facturaSel, pagos: action.data}}
        case SET_DOCSPORIMPRIMIR:
            return {...state, docsPorImprimir: action.data };
        case INICIALIZAR_FACTURA:
            return {...state, facturaSel: action.data };
        case UPDATE_ESTADO_IMPRESION_DOCIMPRIMIR:
            return {...state, docsPorImprimir:
                    actualizarEstadoImpresionDoc(state.docsPorImprimir, action.data)
                };
        case CARGAR_PROFORMAS_A_ENCARTONAR:
            return {...state, proformasAEncartonar: state.proformasAEncartonar.concat(action.proformas) };
        case RESET_PROFORMAS_A_ENCARTONAR:
            return {...state, proformasAEncartonar: []};
        case UPDATE_ESTADO_PROFORMA_ENCARTONADA:
            return {...state, proformasAEncartonar:  state.proformasAEncartonar
                                                    .map(proforma => {
                                                        if (proforma.id === action.data.idProforma) {
                                                            proforma.esEncartonada = action.data.esEncartonada;
                                                        }
                                                        return proforma;
                                                    })
            }
        case CARGAR_ITEMS_A_ENCARTONAR_POR_PROFORMA:
            itemsAEncartonarNewState = state.itemsAEncartonar.concat(action.items);
            return {...state, itemsAEncartonar: itemsAEncartonarNewState, resumenCartones: mapearResumenDeCartones(itemsAEncartonarNewState, state.pesosDeCartones)};
        case DELETE_ITEMS_A_ENCARTONAR_POR_PROFORMA:
            itemsAEncartonarNewState = state.itemsAEncartonar.filter(item => item.proforma!==action.idProforma);
            return { ...state, itemsAEncartonar: itemsAEncartonarNewState, resumenCartones: mapearResumenDeCartones(itemsAEncartonarNewState, state.pesosDeCartones)};
        case RESET_ITEMS_A_ENCARTONAR:
            return  {...state, itemsAEncartonar: [], resumenCartones: [], pesosDeCartones: new Map()};
        case UPDATE_ERRORES_VALIDACION_ITEM_A_ENCARTONAR:
            itemsAEncartonarNewState = state.itemsAEncartonar
                                        .map(item => {
                                            if (item.idItem === action.data.idItem) {
                                                item.erroresDeValidacion = action.data.erroresDeValidacion;
                                            }
                                            return item;
                                        });
            return { ...state, itemsAEncartonar: itemsAEncartonarNewState };
        case ADD_CARTON:
            itemsAEncartonarNewState = state.itemsAEncartonar
                                        .map(item => {
                                            if (item.idItem === action.data.idItem) {
                                                item.detalleCartones = item.detalleCartones.concat(action.data.carton);
                                            }
                                            return item;
                                        });
            return { ...state, itemsAEncartonar: itemsAEncartonarNewState, resumenCartones: mapearResumenDeCartones(itemsAEncartonarNewState, state.pesosDeCartones)};
        case DELETE_CARTON:
            itemsAEncartonarNewState = state.itemsAEncartonar
                                        .map(item => {
                                            if (item.idItem === action.data.idItem) {
                                                item.detalleCartones =  item.detalleCartones.filter(carton => carton.idCarton !== action.data.idCarton)
                                            }
                                            return item;
                                        })
            return { ...state, itemsAEncartonar: itemsAEncartonarNewState, resumenCartones: mapearResumenDeCartones(itemsAEncartonarNewState, state.pesosDeCartones)};
        case UPDATE_CARTON:
            itemsAEncartonarNewState = state.itemsAEncartonar
                                        .map(item => {
                                            if (item.idItem === action.data.idItem) {
                                                item.detalleCartones =  item.detalleCartones.map(carton => {
                                                    if (carton.idCarton === action.data.idCarton || action.data.idCarton === null) {
                                                        carton[action.data.updatedProp] = action.data.updatedValue;
                                                    }
                                                    return carton;
                                                });
                                            }
                                            return item;
                                        });
            return { ...state, itemsAEncartonar: itemsAEncartonarNewState, resumenCartones: mapearResumenDeCartones(itemsAEncartonarNewState, state.pesosDeCartones)};
        case UPDATE_COD_ULT_CARTON:
            return { ...state, ultimoCodCarton: action.ultimoCodCarton};
        case UPDATE_PESO_CARTON:
            return { ...state, resumenCartones: state.resumenCartones.map(carton => {
                                                    if(carton.codCarton === action.data.codCarton) {
                                                        carton.peso = action.data.peso;
                                                    }
                                                    return carton;
                                                }), ultimoCarton: action.data.codCarton };
        case UPDATE_FLAG_PESO_AUTOMATICO:
            return { ...state, resumenCartones: state.resumenCartones.map(carton => {
                                                    if(carton.codCarton === action.data.codCarton) {
                                                        carton.capturaAutomatica = action.data.capturaAutomatica;
                                                    }
                                                    return carton;
                                                })};
        case CARGAR_ENCARTONADO:
            return { ...state, itemsAEncartonar: action.data.itemsAEncartonar,
                    resumenCartones: action.data.resumenCartones,
                    pesosDeCartones: action.data.pesosDeCartones};
        case SET_ENCARTONADO_ID:
            return { ...state, encartonadoId: action.encartonadoId};
        case SET_ENCARTONADO_OBSERVACION:
            return { ...state, encartonadoObservacion: action.observacion};
        case SET_ENCARTONADO_FECHA:
            return { ...state, encartonadoFecha: action.fecha};
        default:
            return state;
    }
};

const actualizarEstadoImpresionDoc = (docsPorImprimir, docAModif) => {
    return docsPorImprimir.map(doc => doc.NroDocumento === docAModif.NroDocumento?
                                        {...doc, EstadoImp: docAModif.EstadoImp } : doc);
}

const mapearResumenDeCartones = (itemsAEncartonar, pesosDeCartones) => {
    let resumenCartones = [];
    const cartones = [].concat(...itemsAEncartonar.map(item => item.detalleCartones));
    const cartonesAgrupados = groupBy(cartones, carton => carton.codCarton);
    for (let codCarton of cartonesAgrupados.keys()) {
        let unidadesPorCarton = cartonesAgrupados.get(codCarton)
                                .map(carton => esNumero(carton.cantidad) ? parseFloat(carton.cantidad) : 0)
                                .reduce((total, value) => total + value, 0);
        resumenCartones = resumenCartones.concat({
                                                    codCarton,
                                                    unidades: unidadesPorCarton,
                                                    peso: pesosDeCartones.has(codCarton)?pesosDeCartones.get(codCarton):'',
                                                    capturaAutomatica: pesosDeCartones.has(codCarton)});
    }
    return resumenCartones.sort(sortResumenCartones);
}

const sortResumenCartones = (a, b) => {
    const codCarton1 = a.codCarton;
    const codCarton2 = b.codCarton;

    if (codCarton1 > codCarton2) {
        return 1;
    }
    if (codCarton2 > codCarton1) {
        return -1;
    }
    return 0;
}

export default ventasReducer;